import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  compact = false,
  ...props
}) {
  // Tamanhos base vs compacto
  const cell = compact ? "h-7 w-7" : "h-8 w-8";
  const headW = compact ? "w-7" : "w-8";
  const rowGap = compact ? "mt-1" : "mt-2";
  const monthGap = compact ? "space-y-2" : "space-y-4";
  const pad = compact ? "p-1.5" : "p-3";

  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn(pad, className)}
      classNames={{
        months: cn("flex flex-col sm:flex-row sm:space-x-4 sm:space-y-0", monthGap),
        month: monthGap,
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: cn("font-medium", compact ? "text-xs" : "text-sm"),
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          compact ? "h-6 w-6" : "h-7 w-7",
          "bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: cn("w-full border-collapse", compact ? "space-y-0" : "space-y-1"),
        head_row: "flex",
        head_cell: cn(
          "text-muted-foreground rounded-md font-normal",
          headW,
          compact ? "text-[0.7rem]" : "text-[0.8rem]"
        ),
        row: cn("flex w-full", rowGap),
        cell: cn(
          "relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-r-md",
          props.mode === "range"
            ? "[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md"
            : "[&:has([aria-selected])]:rounded-md"
        ),
        day: cn(
          buttonVariants({ variant: "ghost" }),
          cell,
          "p-0 font-normal aria-selected:opacity-100",
          compact && "text-xs"
        ),
        day_range_start: "day-range-start",
        day_range_end: "day-range-end",
        day_selected:
          "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside:
          "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle:
          "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <ChevronLeft className={cn(compact ? "h-3.5 w-3.5" : "h-4 w-4", className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <ChevronRight className={cn(compact ? "h-3.5 w-3.5" : "h-4 w-4", className)} {...props} />
        ),
      }}
      {...props} />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
